import { useCreateDataTableOptions } from "@/components/data-table/hooks/useCreateDataTableOptions";
import { QueryTable } from "@/components/query-table/QueryTable";
import { StandardInMemoryTable } from "@/components/in-memory-table/StandardInMemoryTable";
import { mapApiResultsToPeriodRows } from "@/modules/contractorsPlannedHoursWizard/utils/mapApiResultsToPeriodRows";
import { displayContractorsPlannedHoursWizardResult } from "@/schemas/contractorsPlannedHoursWizard";
import {
  DisplayContractorsPlannedHoursWizardResult,
  ReadContractorsPlannedHoursWizardResult,
} from "@/types/contractorsPlannedHoursWizard";
import { DataTableFeatures } from "@/types/dataTableSettings";
import { useMemo } from "react";

export function ContractorsPlannedHoursWizardCalculationResultsList({
  results,
}: {
  results: ReadContractorsPlannedHoursWizardResult[];
}) {
  const rows = useMemo(() => mapApiResultsToPeriodRows(results), [results]);
  const localFeatures = useMemo(
    (): DataTableFeatures => ({
      enableRowSelection: false,
      enableFilters: false,
      enableSorting: false,
      enableColumnPinning: true,
      enableColumnOrder: true,
    }),
    [],
  );
  const options =
    useCreateDataTableOptions<DisplayContractorsPlannedHoursWizardResult>(
      "contractorsPlannedHoursWizardResults",
    );

  return (
    <StandardInMemoryTable<DisplayContractorsPlannedHoursWizardResult>
      schema={displayContractorsPlannedHoursWizardResult}
      name="contractorsPlannedHoursWizardResults"
      translationKey="contractorsPlannedHoursWizard"
      items={rows}
      options={options}
      tableFeatures={localFeatures}
    >
      <div className="flex min-h-0 flex-1 flex-col gap-1">
        <div className="flex flex-row items-center gap-2 py-1">
          <QueryTable.Menubar className="mb-0 min-w-0 w-full flex-1 justify-start">
            <QueryTable.Menubar.Columns />
            <QueryTable.Menubar.Settings />
          </QueryTable.Menubar>
        </div>
        <div className="mb-1 flex min-h-32 flex-1 flex-col gap-1">
          <StandardInMemoryTable.Content className="min-h-0 flex-1 flex-col" />
        </div>
      </div>
    </StandardInMemoryTable>
  );
}
